import { createAction } from '../../../../store.model';
import { ActionType } from '../task-list-dialog.action';

export interface EditItem {
    msftTaskId: string;
    edit: boolean;
}

export const editItem = createAction<ActionType, EditItem>(
    ActionType.TC__TL__EDIT_ITEM,
);
